import { render, staticRenderFns } from "./sidebarItem.vue?vue&type=template&id=13d0e1a7&scoped=true"
import script from "./sidebarItem.vue?vue&type=script&lang=js"
export * from "./sidebarItem.vue?vue&type=script&lang=js"
import style0 from "./sidebarItem.vue?vue&type=style&index=0&id=13d0e1a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d0e1a7",
  null
  
)

export default component.exports